"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgGestureTouch(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm13.9997 8.1597a1.0506 1.0506 0 0 0 -1.08649-1.0153 1.02946 1.02946 0 0 0 -.90822.4907v-.0339a1.06467 1.06467 0 0 0 -1.08659-1.0322 1.054 1.054 0 0 0 -.90851.4739v-.0169a1.0645 1.0645 0 0 0 -1.08659-1.0323 1.05344 1.05344 0 0 0 -.90832.4738l-.01293.0182v-3.4857a1.00071 1.00071 0 0 0 -2.00142 0v6.2814a.12125.12125 0 0 1 -.12787-.0355l-1.06975-1a1.08824 1.08824 0 0 0 -1.34594-.1148.99811.99811 0 0 0 -.44865.6886.9502.9502 0 0 0 .24158.7869l2.6401 3.0328a3.9534 3.9534 0 0 0 3.01967 1.3606h1.63915a3.48331 3.48331 0 0 0 2.43293-.9672 3.172 3.172 0 0 0 1.01815-2.3115z' })));
}
exports.default = SvgGestureTouch;
